module.exports = __webpack_public_path__ + "static/media/cartaz1.eebe33d8.png";